import * as types from '../ActionTypes/GymTvActionTypes';
import { modalTypes } from '../../UI/Containers/GymAdminPanel/GymTv/constants';

const initialState = {
    statuses: {
        channelsLoading: false,
        currentChannelLoading: false,
        isChannelCreating: false,
        classesLoading: false,
        updatingChannelId: null,
    },
    channels: [],
    currentChannel: {},
    classes: [],
};

export function GymTvReducer(state = initialState, { type, payload, meta, ...action }) {
    switch (type) {
        case types.GET_GYM_TV_CHANNELS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    channelsLoading: true,
                },
            };
        }

        case types.GET_GYM_TV_CHANNELS_SUCCESS: {
            return {
                ...state,
                channels: [...payload],
                statuses: {
                    ...state.statuses,
                    channelsLoading: false,
                },
            };
        }

        case types.GET_GYM_TV_CHANNELS_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    channelsLoading: false,
                },
            };
        }

        case types.CREATE_GYM_TV_CHANNEL_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isChannelCreating: true,
                },
            };
        }

        case types.CREATE_GYM_TV_CHANNEL_SUCCESS: {
            const newChannel = { id: payload.id };
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isChannelCreating: false,
                },
                channels: [...state.channels, newChannel],
            };
        }

        case types.CREATE_GYM_TV_CHANNEL_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isChannelCreating: false,
                },
            };
        }

        case types.GET_GYM_TV_CHANNEL_BY_ID_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    currentChannelLoading: true,
                },
            };
        }

        case types.GET_GYM_TV_CHANNEL_BY_ID_SUCCESS: {
            return {
                ...state,
                currentChannel: { ...payload },
                statuses: {
                    ...state.statuses,
                    currentChannelLoading: false,
                },
            };
        }

        case types.GET_GYM_TV_CHANNEL_BY_ID_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    currentChannelLoading: false,
                },
            };
        }

        case types.UPDATE_GYM_TV_CHANNEL_SUCCESS: {
            const channelsList = [...state.channels];
            const replaceIndex = channelsList.findIndex(channel => channel.id === payload.id);
            if (replaceIndex !== -1) channelsList[replaceIndex] = { ...payload };

            return {
                ...state,
                channels: [...channelsList],
            };
        }

        case types.DELETE_GYM_TV_CHANNEL_REQUEST: {
            const { channelId } = meta;
            const channelsList = [...state.channels];
            const removeIndex = channelsList.findIndex(channel => channel.id === channelId);
            if (removeIndex !== -1) channelsList.splice(removeIndex, 1);

            return {
                ...state,
                channels: [...channelsList],
            };
        }

        case types.DUPLICATE_GYM_TV_CHANNEL_SUCCESS: {
            return {
                ...state,
                channels: [...state.channels, { ...payload }],
            };
        }

        case types.GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    classesLoading: true,
                },
            };
        }

        case types.GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_SUCCESS: {
            const classesList = payload.sort((first, second) => first.start - second.start);
            return {
                ...state,
                classes: [...classesList],
                statuses: {
                    ...state.statuses,
                    classesLoading: false,
                },
            };
        }

        case types.GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    classesLoading: false,
                },
            };
        }

        case types.ADD_GYM_TV_CHANNEL_ITEM_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    updatingChannelId: meta.channelId,
                },
            };
        }

        case types.ADD_GYM_TV_CHANNEL_ITEM_SUCCESS: {
            const {
                statuses: { updatingChannelId },
                channels,
            } = state;

            const newChannelsList = channels.map(channel => {
                if (channel.id === updatingChannelId) {
                    switch (payload.type) {
                        case modalTypes.BEFORE_CLASS: {
                            channel.before = { data: { ...payload } };
                            break;
                        }
                        case modalTypes.DURING_CLASS: {
                            channel.during = { data: { ...payload } };
                            break;
                        }
                        case modalTypes.AFTER_CLASS: {
                            channel.after = { data: { ...payload } };
                            break;
                        }
                        case modalTypes.BETWEEN_CLASSES: {
                            channel.between = { data: [...payload] };
                        }
                    }
                }

                return channel;
            });

            return {
                ...state,
                channels: [...newChannelsList],

                statuses: {
                    ...state.statuses,
                    updatingChannelId: null,
                },
            };
        }

        // case types.ADD_GYM_TV_CHANNEL_ITEM_SUCCESS: {
        //     return {
        //         ...state,

        //     }
        // }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/GymTvReducer.js